module.exports = __webpack_public_path__ + "img/bannerN2.756be03c.png";